import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import FormAsyncSelectField from '../../common/components/formFields/FormAsyncSelectField';
import { dataToSelect } from '../../common/helpers';
import { getDealers } from '../DealersActions';
import { SET_DEALERS_SELECT_SEARCH_STATE } from '../DealersReducer';

function DealersSelectField(props) {
  const dispatch = useDispatch();
  const [initialOptions, setInitialOptions] = useState([]);

  const fetchDealers = useCallback(
    (input = '', callback) => {
      dispatch(
        getDealers(input, (response) => {
          const options = dataToSelect(response?.data?.content, ['id', 'tradeName']);
          dispatch({ type: SET_DEALERS_SELECT_SEARCH_STATE, payload: options });
          callback?.(options);
          if (!input) setInitialOptions(options);
        }),
      );
    },
    [dispatch],
  );

  useEffect(() => {
    fetchDealers();
  }, [fetchDealers]);

  return (
    <FormAsyncSelectField
      {...props}
      loadOptions={_.debounce(fetchDealers, 500)}
      defaultOptions={initialOptions.length ? initialOptions : true}
    />
  );
}

export default DealersSelectField;
